/**
 * This browser's clock read against Cloudflare's, through the live Worker's
 * `/time`. The API stamps when a live went live on Cloudflare's clock, so a
 * page whose own clock is a little off still shows the right elapsed time.
 */

interface ClockCheck {
  /** Cloudflare's clock minus this one, in ms. */
  off: number;
  /** The round trip it was read over. */
  rtt: number;
}

/** The fastest of `rounds` round trips to `/time`: the shortest trip reads the clock best. */
export async function checkClock(origin: string, rounds = 8): Promise<ClockCheck | null> {
  let best: ClockCheck | null = null;
  for (let i = 0; i < rounds; i++) {
    try {
      const t0 = Date.now();
      const res = await fetch(`${origin}/time`, { cache: "no-store" });
      const { now } = (await res.json()) as { now: number };
      const t1 = Date.now();
      if (!best || t1 - t0 < best.rtt) best = { rtt: t1 - t0, off: now - (t0 + t1) / 2 };
    } catch {
      return best;
    }
  }
  return best;
}
